module.exports = __webpack_public_path__ + "images/minimiseac5df2a27b247f057f2431cfcb735928.svg";